export const MULTI_QUERY_SEPARATOR = ',';
export const QUERY_VALUE_SEPARATOR = ':';
export const FILTER_VALUE_START_SEPARATOR = '[';
export const FILTER_VALUE_END_SEPARATOR = ']';
export const DEFAULT_FILTER_VALUE = 'default';
export const FILTER_COMPLEX_VALUE_SEPARATOR = '+';
export const FILTER_SEPARATOR = '=';
